import { useEffect, useState } from "react"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { IOcupacao } from "../../../../../../../application/models"
import { useOcupacaoService, useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Autocomplete, debounce, Grid, TextField } from "@mui/material"
// Icon

export const RecorteProfissao = () => {
    // Redux State
    const { ocupacoes, searchTerm } = useAppSelector((state) => state.ocupacao)
    const { openForm, editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)

    // Local State
    const [selectedProfissao, setSelectedProfissao] = useState<IOcupacao[]>([])

    // Hooks
    const {
        setCategoria,
        setSearchTerm,
        searchOcupacoes,
        resetCategoria,
        resetOcupacoes,
        resetSearchTerm
    } = useOcupacaoService()
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    // Effects
    useEffect(() => {
        const profissoesSelecionadas = editRecorteExtracaoForm.fields.Filtros?.profissao || [];

        if (profissoesSelecionadas.length > 0) {
            setSelectedProfissao(profissoesSelecionadas);
        } else {
            setSelectedProfissao([]);
        }
    }, [editRecorteExtracaoForm.fields.Filtros?.profissao]);

    useEffect(() => {
        if (searchTerm.length > 0) {
            searchOcupacoes()
        }
    }, [searchOcupacoes, searchTerm])

    useEffect(() => {
        resetCategoria()
        resetOcupacoes()
        resetSearchTerm()
    }, [openForm, resetCategoria, resetOcupacoes, resetSearchTerm])

    // Filter options to show only non-selected professions
    const filteredOcupacoes = (ocupacoes || []).filter((ocupacao) =>
        !selectedProfissao.some(selected =>
            selected.cbocodigo === ocupacao.cbocodigo
        )
    );

    // Functions
    const debouncedSetSearchTerm = debounce((newSearchTerm) => {
        setCategoria('familiasearch')
        setSearchTerm(newSearchTerm);
    }, 500);

    const handleProfissaoSelectionChange = (value: IOcupacao[]) => {
        setSelectedProfissao(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'profissao',
                value: value,
                formType: 'edit'
            });
        } else {
            removeFilterFromForm({
                filtro: 'profissao',
                formType: 'edit'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredOcupacoes}
                    value={selectedProfissao}
                    getOptionLabel={(option) => option.cbodescricao ? `${option.cbocodigo} - ${option.cbodescricao.toUpperCase()}` : ''}
                    isOptionEqualToValue={(option, value) =>
                        option.cbocodigo === value.cbocodigo
                    }
                    sx={{
                        px: 2
                    }}
                    onInputChange={(event, newInputValue) => {
                        debouncedSetSearchTerm(newInputValue)
                    }}
                    onChange={(event, value) => {
                        handleProfissaoSelectionChange(value);
                    }}
                    noOptionsText={searchTerm.length > 1 ? 'Nenhuma profissão encontrada' : 'Digite o número ou descrição da profissão'}
                    filterSelectedOptions={true}
                    disableCloseOnSelect
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Lista de Profissões"
                        />
                    )}
                />
            </Grid>
        </>
    )
}